(function () {
  'use strict';

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var decimals = amount % 1 ? 2 : 0;
    return '$' + amount.toFixed(decimals);
  }

  function initPage(root) {
    if (root.dataset.novoReady === 'true') return;
    root.dataset.novoReady = 'true';
    var orderForm = root.querySelector('[data-novo-order-form]');
    var form = root.querySelector('#novo-product-form');
    var selectedVariantPrice = 0;
    var variantDataElement = root.querySelector('[data-novo-variants]');
    var variantData = variantDataElement ? JSON.parse(variantDataElement.textContent) : { optionNames: [], variants: [] };
    var variants = variantData.variants || [];
    var optionNames = variantData.optionNames || [];
    var selectedVariantInput = root.querySelector('[data-novo-selected-variant]');
    var currentVariant = variants.find(function (variant) { return String(variant.id) === String(selectedVariantInput && selectedVariantInput.value); }) || variants[0];
    var selectedModelValue = currentVariant && currentVariant.options ? currentVariant.options[0] : '';

    function selectedAccessories() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-novo-accessory]:checked'));
    }

    function updateConfiguredPrice() {
      var accessories = selectedAccessories();
      var accessoryTotal = accessories.reduce(function (total, input) {
        return total + (input.dataset.novoVolumeFree === 'true' ? 0 : Number(input.dataset.price || 0));
      }, 0);
      root.querySelectorAll('[data-novo-accessory]').forEach(function (input) {
        var card = input.closest('.novo-accessory-card');
        card.classList.toggle('is-selected', input.checked);
      });
      var total = selectedVariantPrice + accessoryTotal;
      root.querySelectorAll('[data-novo-button-price],[data-novo-sticky-price]').forEach(function (element) { element.textContent = money(total); });
      var message = root.querySelector('[data-novo-accessory-message]');
      if (message) message.textContent = 'Add any useful extras to your order.';
      return { total: total };
    }

    function updateVolumeKnobOffer() {
      var isPremium = /premium/i.test(String(selectedModelValue || ''));
      var isSevenInch = Boolean(root.querySelector('[data-novo-question="screen-size"] [data-novo-answer="7-inch"]:checked'));
      var knob = root.querySelector('[data-novo-volume-knob]');
      var touch = root.querySelector('[data-novo-screen-variant]:not([data-novo-volume-knob])');
      var knobCard = root.querySelector('[data-novo-volume-knob-card]');
      var availability = root.querySelector('[data-novo-knob-availability]');
      var knobAvailable = isPremium && !isSevenInch;
      if (knob) knob.disabled = isSevenInch;
      if (knobCard) knobCard.classList.toggle('is-premium-locked', !knobAvailable);
      if (availability) {
        availability.textContent = isSevenInch ? 'Only available on 9 inch' : 'Only available on Premium model';
        availability.hidden = knobAvailable;
      }
      if (!knobAvailable && touch) {
        touch.checked = true;
        root.querySelectorAll('.novo-screen-style-card').forEach(function (card) { card.classList.toggle('is-selected', card.contains(touch)); });
      }
      var dashCam = root.querySelector('[data-novo-volume-dash]');
      var volumeKnobSelected = Boolean(isPremium);
      if (dashCam) {
        if (volumeKnobSelected && !dashCam.checked) dashCam.dataset.novoAutoSelected = 'true';
        if (volumeKnobSelected) dashCam.checked = true;
        else if (dashCam.dataset.novoAutoSelected === 'true') dashCam.checked = false;
        if (!volumeKnobSelected) delete dashCam.dataset.novoAutoSelected;
        dashCam.disabled = Boolean(volumeKnobSelected);
        dashCam.dataset.novoVolumeFree = volumeKnobSelected ? 'true' : 'false';
      }
      var dashCard = root.querySelector('[data-novo-volume-dash-card]');
      if (dashCard) dashCard.classList.toggle('is-volume-free', Boolean(volumeKnobSelected));
      var freeLabel = root.querySelector('[data-novo-dash-free]');
      var paidPrice = root.querySelector('[data-novo-dash-price]');
      if (freeLabel) freeLabel.hidden = !volumeKnobSelected;
      if (paidPrice) paidPrice.classList.toggle('is-free-original-price', Boolean(volumeKnobSelected));
    }

    function selectedPricedOptions(fallbackVariant) {
      var values = {};
      root.querySelectorAll('[data-novo-shopify-option]:checked').forEach(function (input) {
        values[input.dataset.novoShopifyOption] = input.dataset.novoShopifyValue;
      });
      optionNames.slice(1).forEach(function (name, index) {
        if (!values[name] && fallbackVariant && fallbackVariant.options) values[name] = fallbackVariant.options[index + 1];
      });
      return values;
    }

    function findVariant(modelValue, fallbackVariant) {
      var priced = selectedPricedOptions(fallbackVariant || currentVariant);
      return variants.find(function (variant) {
        if (!variant.options || variant.options[0] !== modelValue) return false;
        return optionNames.slice(1).every(function (name, index) { return variant.options[index + 1] === priced[name]; });
      });
    }

    function updateChoicePrices() {
      var isPremium = /premium/i.test(String(selectedModelValue || ''));
      var isSevenInch = Boolean(root.querySelector('[data-novo-question="screen-size"] [data-novo-answer="7-inch"]:checked'));
      root.querySelectorAll('[data-novo-model-price]').forEach(function (element) {
        var variant = findVariant(element.dataset.novoModelValue, currentVariant);
        if (variant) element.textContent = money(variant.price);
      });
      root.querySelectorAll('[data-novo-screen-variant]').forEach(function (screenInput) {
        var price = screenInput.closest('.novo-screen-style-card').querySelector('[data-novo-screen-price]');
        if (!price) return;
        var isKnob = screenInput.hasAttribute('data-novo-volume-knob');
        var screenModelValue = isKnob ? screenInput.dataset.novoModelValue : (isPremium ? 'Premium' : 'Standard');
        var variant = findVariant(screenModelValue, currentVariant);
        if (variant) price.textContent = money(variant.price);
        price.classList.toggle('is-unavailable-price', isKnob && (!isPremium || isSevenInch));
      });
    }

    root.querySelectorAll('[data-novo-gallery-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var index = button.getAttribute('data-novo-gallery-thumb');
        root.querySelectorAll('[data-novo-gallery-thumb]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
        root.querySelectorAll('[data-novo-gallery-main]').forEach(function (media) {
          var active = media.getAttribute('data-novo-gallery-main') === index;
          media.classList.toggle('is-hidden', !active);
          if (media.tagName === 'VIDEO') {
            media.muted = true;
            if (active) media.play().catch(function () {}); else media.pause();
          }
        });
      });
    });

    var gallery = root.querySelector('[data-novo-gallery]');
    if (gallery && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        root.querySelectorAll('.novo-main-video').forEach(function (video) {
          if (!entries[0].isIntersecting || video.classList.contains('is-hidden')) video.pause();
          else { video.muted = true; video.play().catch(function () {}); }
        });
      }, {threshold: .25}).observe(gallery);
    }

    root.querySelectorAll('[data-novo-inline-video]').forEach(function (section) {
      var video = section.querySelector('video');
      if (!video || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { video.muted = true; video.play().catch(function () {}); } else video.pause();
      }, {threshold: .25}).observe(section);
    });

    function selectVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      selectedModelValue = variant.options && variant.options[0] ? variant.options[0] : selectedModelValue;
      if (selectedVariantInput) selectedVariantInput.value = variant.id;
      var price = Number(variant.price || 0);
      var compare = Number(variant.compare_at_price || 0);
      selectedVariantPrice = price;
      root.querySelectorAll('[data-novo-price]').forEach(function (element) { element.textContent = money(price); });
      var compareElement = root.querySelector('[data-novo-compare-price]');
      var savingElement = root.querySelector('[data-novo-saving]');
      if (compareElement) { compareElement.hidden = compare <= price; compareElement.textContent = money(compare); }
      if (savingElement) { savingElement.hidden = compare <= price; savingElement.textContent = 'Save ' + money(compare - price); }
      var shipping = root.querySelector('[data-novo-free-shipping]');
      if (shipping) shipping.hidden = price < 10000;
      root.querySelectorAll('[data-novo-afterpay-amount]').forEach(function (element) { element.textContent = money(price / 4); });
      root.querySelectorAll('[data-novo-model-value]').forEach(function (input) {
        if (input.matches('input[name="novo_model"]')) input.checked = input.value === selectedModelValue || (selectedModelValue.indexOf('Premium') !== -1 && input.value === 'Premium');
      });
      root.querySelectorAll('.novo-model-card').forEach(function (card) { card.classList.toggle('is-selected', Boolean(card.querySelector('input[name="novo_model"]:checked'))); });
      var modelComparison = root.querySelector('[data-novo-model-comparison]');
      if (modelComparison) {
        var premiumSelected = /premium/i.test(String(selectedModelValue || ''));
        modelComparison.classList.toggle('is-premium-selected', premiumSelected);
        modelComparison.classList.toggle('is-standard-selected', !premiumSelected);
      }
      root.querySelectorAll('[data-novo-screen-variant]').forEach(function (input) { input.checked = input.value === selectedModelValue; });
      root.querySelectorAll('.novo-screen-style-card').forEach(function (card) { card.classList.toggle('is-selected', Boolean(card.querySelector('[data-novo-screen-variant]:checked'))); });
      updateVolumeKnobOffer();
      updateChoicePrices();
      updateConfiguredPrice();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('input[name="novo_model"]').forEach(function (input) {
      input.addEventListener('change', function () {
        selectedModelValue = input.value;
        if (selectedModelValue === 'Premium') {
          var selectedStyle = root.querySelector('[data-novo-screen-variant]:checked');
          if (selectedStyle && selectedStyle.dataset.novoModelValue.indexOf('Premium') !== -1) selectedModelValue = selectedStyle.dataset.novoModelValue;
        }
        selectVariant(findVariant(selectedModelValue, currentVariant));
      });
    });
    var modelComparison = root.querySelector('[data-novo-model-comparison]');
    if (modelComparison) {
      modelComparison.querySelectorAll('[data-select-model]').forEach(function (cell) {
        var model = cell.dataset.selectModel;
        cell.tabIndex = 0;
        cell.setAttribute('role', 'button');
        cell.setAttribute('aria-label', 'Select ' + (model === 'premium' ? 'Premium' : 'Standard'));
        function selectColumn() {
          var input = modelComparison.querySelector('input[data-novo-model="' + model + '"]');
          if (!input || input.checked) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
        cell.addEventListener('click', selectColumn);
        cell.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          selectColumn();
        });
      });
    }
    root.querySelectorAll('.novo-compare-models-link').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          target.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth', block: 'start'});
        } catch (error) {
          target.scrollIntoView();
        }
        window.history.replaceState({}, '', link.getAttribute('href'));
      });
    });
    root.querySelectorAll('[data-novo-screen-variant]').forEach(function (screenInput) {
      screenInput.addEventListener('change', function () {
        var isKnob = screenInput.hasAttribute('data-novo-volume-knob');
        selectedModelValue = isKnob ? screenInput.dataset.novoModelValue : (/premium/i.test(String(selectedModelValue || '')) ? 'Premium' : 'Standard');
        selectVariant(findVariant(selectedModelValue, currentVariant));
      });
    });
    if (currentVariant) selectVariant(currentVariant);
    root.querySelectorAll('[data-novo-accessory]').forEach(function (input) { input.addEventListener('change', updateConfiguredPrice); });

    function setQuestionValidity(field, incomplete, animate) {
      field.toggleAttribute('data-novo-incomplete', incomplete);
      field.setAttribute('aria-invalid', incomplete ? 'true' : 'false');
      var error = field.querySelector('[data-novo-question-error]');
      if (error) error.hidden = !incomplete;
      field.classList.remove('is-novo-error-pulse');
      if (incomplete && animate) {
        void field.offsetWidth;
        field.classList.add('is-novo-error-pulse');
      }
    }

    function updateDependencies(questionId, optionId) {
      var affectedOptionFields = [];
      root.querySelectorAll('[data-novo-show-question]').forEach(function (field) {
        if (field.dataset.novoShowQuestion !== questionId) return;
        var visible = (field.dataset.novoShowOptions || '').split(',').indexOf(optionId) !== -1;
        field.hidden = !visible;
        if (!visible) {
          field.querySelectorAll('input').forEach(function (input) { input.checked = false; });
          setQuestionValidity(field, false, false);
        }
      });
      root.querySelectorAll('[data-novo-show-option]').forEach(function (card) {
        if (card.dataset.novoShowOption !== questionId) return;
        var optionField = card.closest('[data-novo-question]');
        if (optionField && affectedOptionFields.indexOf(optionField) === -1) affectedOptionFields.push(optionField);
        var visible = (card.dataset.novoShowOptions || '').split(',').indexOf(optionId) !== -1;
        card.hidden = !visible;
        if (!visible) {
          card.classList.remove('is-selected');
          card.querySelectorAll('input').forEach(function (input) { input.checked = false; });
        }
      });
      affectedOptionFields.forEach(function (field) {
        var cards = Array.from(field.querySelectorAll('.novo-answer-card'));
        var visibleCards = cards.filter(function (card) { return !card.hidden; });
        var checked = field.querySelector('[data-novo-answer]:checked');
        if (!checked && visibleCards.length === 1) {
          var onlyInput = visibleCards[0].querySelector('[data-novo-answer]');
          if (onlyInput && !onlyInput.disabled) {
            onlyInput.checked = true;
            onlyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }
    root.querySelectorAll('[data-novo-answer]').forEach(function (input) {
      input.addEventListener('change', function () {
        var field = input.closest('[data-novo-question]');
        if (!field) return;
        setQuestionValidity(field, false, false);
        field.querySelectorAll('.novo-answer-card').forEach(function (card) { card.classList.toggle('is-selected', card.contains(input)); });
        var confirmation = field.querySelector('[data-novo-confirmation-message]');
        if (confirmation) { confirmation.textContent = input.dataset.novoConfirmation || ''; confirmation.hidden = !input.dataset.novoConfirmation; }
        updateDependencies(field.dataset.novoQuestion, input.dataset.novoAnswer);
        if (field.dataset.novoQuestion === 'screen-size' && input.dataset.novoAnswer === '7-inch' && /volume knob/i.test(String(selectedModelValue || ''))) {
          selectVariant(findVariant('Premium', currentVariant));
          return;
        }
        updateVolumeKnobOffer();
        updateChoicePrices();
        if (input.dataset.novoShopifyOption) selectVariant(findVariant(selectedModelValue, currentVariant));
      });
    });
    root.querySelectorAll('[data-novo-answer]:checked').forEach(function (input) {
      var field = input.closest('[data-novo-question]');
      if (field) updateDependencies(field.dataset.novoQuestion, input.dataset.novoAnswer);
    });
    updateVolumeKnobOffer();

    var sticky = root.querySelector('[data-novo-sticky-order]');
    if (sticky && orderForm && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      }, { threshold: 0 }).observe(orderForm);
    }
    if (sticky) sticky.addEventListener('click', function (event) { event.preventDefault(); orderForm.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var firstIncomplete = null;
        root.querySelectorAll('[data-novo-question]:not([hidden])').forEach(function (field) {
          var incomplete = !field.querySelector('input:checked');
          setQuestionValidity(field, incomplete, true);
          if (incomplete && !firstIncomplete) firstIncomplete = field;
        });
        if (firstIncomplete) {
          firstIncomplete.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          window.setTimeout(function () { firstIncomplete.focus({ preventScroll: true }); }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350);
          return;
        }

        var submitButton = form.querySelector('[type="submit"]');
        var submitSpinner = submitButton.querySelector('.loading__spinner');
        var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
        var errorText = form.querySelector('.product-form__error-message');
        submitButton.classList.add('loading');
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        if (submitSpinner) submitSpinner.classList.remove('hidden');
        if (errorWrapper) errorWrapper.hidden = true;

        Promise.all([fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); })]).then(function (results) {
          var cartState = results[0];
          var quantities = {};
          cartState.items.forEach(function (item) { quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity; });
          var formData = new FormData(form);
          var variantId = Number(formData.get('id'));
          var properties = {};
          formData.forEach(function (value, key) {
            if (key.indexOf('properties[') === 0 && typeof value === 'string' && value) properties[key.slice(11, -1)] = value;
          });
          updateConfiguredPrice();
          var requested = [{ id: variantId, quantity: 1, properties: properties }];
          selectedAccessories().forEach(function (input) {
            var accessoryId = Number(input.dataset.variantId);
            var isVolumeKnobGift = input.dataset.novoVolumeFree === 'true';
            if (isVolumeKnobGift || !quantities[accessoryId]) requested.push({ id: accessoryId, quantity: 1, properties: isVolumeKnobGift ? {'_Novo Premium Gift': 'Dash cam', '_Novo VolumeKnob Gift': 'Dash cam'} : {} });
          });
          var items = requested;
          var drawer = document.querySelector('cart-drawer');
          if (!items.length) { if (drawer) drawer.open(); return null; }
          var payload = { items: items };
          if (drawer && drawer.getSectionsToRender) {
            payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
            payload.sections_url = window.location.pathname;
          }
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload)
          }).then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Unable to add this configuration.'); return data; }); }).then(function (data) { if (drawer) drawer.classList.remove('is-empty'); if (drawer && data.sections) drawer.renderContents(data); else if (drawer) drawer.open(); });
        }).catch(function (error) {
          if (errorText) errorText.textContent = error.message;
          if (errorWrapper) errorWrapper.hidden = false;
        }).finally(function () {
          submitButton.classList.remove('loading');
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          if (submitSpinner) submitSpinner.classList.add('hidden');
        });
      }, true);
    }
  }

  function initUgc(section) {
    if (section.dataset.novoReady === 'true') return;
    section.dataset.novoReady = 'true';
    var track = section.querySelector('[data-novo-ugc-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-novo-ugc-card]'));
    var activeIndex = 0;
    var inView = false;
    function loadCard(card) {
      var source = card.querySelector('source[data-src]');
      if (source) {
        var video = card.querySelector('video');
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.preload = 'auto';
        video.load();
      }
    }
    function loadNeighbours(index) {
      loadCard(cards[index]);
      loadCard(cards[(index + 1) % cards.length]);
      loadCard(cards[(index - 1 + cards.length) % cards.length]);
    }
    function activate(index, shouldPlay, allowSound) {
      activeIndex = (index + cards.length) % cards.length;
      loadNeighbours(activeIndex);
      cards.forEach(function (card, cardIndex) {
        var video = card.querySelector('video');
        var active = cardIndex === activeIndex;
        card.classList.toggle('is-active', active);
        video.muted = !active || !allowSound;
        if (!active || !inView) { video.pause(); card.classList.remove('is-playing'); }
      });
      var activeCard = cards[activeIndex];
      activeCard.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      if (shouldPlay && inView) activeCard.querySelector('video').play().then(function () { activeCard.classList.add('is-playing'); }).catch(function () {});
    }
    section.querySelector('[data-novo-ugc-prev]').addEventListener('click', function () { activate(activeIndex - 1, true, true); });
    section.querySelector('[data-novo-ugc-next]').addEventListener('click', function () { activate(activeIndex + 1, true, true); });
    cards.forEach(function (card, index) { card.querySelector('[data-novo-video-toggle]').addEventListener('click', function () { var video = card.querySelector('video'); if (index !== activeIndex) return activate(index, true, true); if (video.paused) { video.muted = false; video.play().then(function () { card.classList.add('is-playing'); }).catch(function () {}); } else { video.pause(); card.classList.remove('is-playing'); } }); });
    var scrollTimer;
    track.addEventListener('scroll', function () { clearTimeout(scrollTimer); scrollTimer = setTimeout(function () { var centre = track.getBoundingClientRect().left + track.clientWidth / 2; var nearest = 0; var distance = Infinity; cards.forEach(function (card, index) { var rect = card.getBoundingClientRect(); var current = Math.abs(rect.left + rect.width / 2 - centre); if (current < distance) { distance = current; nearest = index; } }); if (nearest !== activeIndex) activate(nearest, true, false); }, 100); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadNeighbours(activeIndex);
      }, { rootMargin: '400px 0px', threshold: 0 }).observe(section);
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; if (!inView) cards.forEach(function (card) { card.querySelector('video').pause(); card.classList.remove('is-playing'); }); else activate(activeIndex, true, false); }, { threshold: .35 }).observe(section);
    } else {
      loadNeighbours(activeIndex);
    }
  }

  function init() {
    document.querySelectorAll('[data-novo-product-page]').forEach(initPage);
    document.querySelectorAll('[data-novo-ugc]').forEach(initUgc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
